module.exports = __webpack_public_path__ + "img/p3_12.7d9ca7da.webp";